<script lang="ts" setup></script>
<template>
  <div class="flex full-height align-items-center justify-center">
    <h1>404</h1>
  </div>
</template>
